import { useAppDispatch } from 'store/hooks';
import channelSelectors from '../selectors';
import channelActions from '../actions';
import { useEffect } from 'react';

interface IApiGetListChannelsParam {
  keySearch?: string;
  from: number;
  size: number;
}

const useGetListChannels = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const data = channelSelectors.getListChannels();

  const mutate = (params: IApiGetListChannelsParam) => {
    dispatch(
      channelActions.getListChannels.fetch({
        page: params.from,
        size: params.size,
        keySearch: params.keySearch,
      })
    );
  };

  useEffect(() => {
    if (!isLazy) {
      mutate({ from: 1, size: 10 });
    }
  }, []);

  return [data, mutate] as const;
};

export default useGetListChannels;
